<template>
  <a-row class="performer-project-form__row">
    <a-col>
      <slot></slot>
    </a-col>
    <a-col class="performer-project-form__available">
      <c-checkbox
        v-if="showAvailable"
        :checked="available"
        @change="changeHandler"
        :class="{ margined: offsetAvailable }"
      >
        Доступно для партнера
      </c-checkbox>
    </a-col>
  </a-row>
</template>

<script setup>
  import CCheckbox from '@/components/UI/CCheckbox.vue';

  defineProps({
    showAvailable: {
      type: Boolean,
      default: false,
    },
    offsetAvailable: {
      type: Boolean,
      default: true,
    },
    available: {
      type: Boolean,
      default: false,
    },
  });

  const changeHandler = (value) => {
    this.$emit('change', value);
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .performer-project-form__row {
    flex-wrap: nowrap;
    & > .ant-col:first-child {
      flex: 1 1 100%;
    }

    &.bordered {
      border-bottom: 1px solid $color-line;
      padding-bottom: 6px;
      margin-bottom: 30px;
    }

    :deep(.button-add) {
      margin-left: 30px;
    }
  }
  .performer-project-form__available {
    flex: 0 0 215px;
    padding-left: 20px;
    padding-top: 9px;

    .margined {
      margin-top: 30px;
    }
  }
</style>
